module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('el-form', {
    staticClass: "searchForm",
    attrs: {
      "inline": true,
      "model": _vm.formFuzzy,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "内容提供商名称:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入提供商名称"
    },
    model: {
      value: (_vm.formFuzzy.namer),
      callback: function($$v) {
        _vm.$set(_vm.formFuzzy, "namer", $$v)
      },
      expression: "formFuzzy.namer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.onQuery
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "btn_add_new_cp",
    attrs: {
      "type": "primary",
      "icon": "el-icon-folder-add"
    },
    on: {
      "click": _vm.addcp
    }
  }, [_vm._v("新建内容提供商")])], 1), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "50px",
      "font-size": "12px"
    },
    attrs: {
      "data": _vm.queryData,
      "header-cell-style": _vm.rowClass,
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.id))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "内容提供商",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "logo",
      "label": "封面",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": scope.row.logo,
            "min-width": "70",
            "height": "70"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appName",
      "label": "来源",
      "align": "center",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "created_at",
      "label": "创建时间",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("formatDate2")(scope.row.created_at)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": "",
      "align": "center",
      "width": "180",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "管理内容",
            "placement": "top"
          }
        }, [(scope.row.type == 'own') ? _c('el-button', {
          attrs: {
            "type": "info",
            "size": "mini",
            "icon": "el-icon-folder",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.bookInfo(scope.row)
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "编辑",
            "placement": "top"
          }
        }, [(scope.row.type == 'own') ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-edit",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "删除",
            "placement": "top"
          }
        }, [(scope.row.type == 'own') ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "el-icon-delete",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.handleDelete(scope.row.id)
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "查看内容",
            "placement": "top"
          }
        }, [(scope.row.type == 'share') ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-reading",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.handleView(scope.row)
            }
          }
        }) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editId ? '编辑内容提供商' : '新建内容提供商',
      "visible": _vm.dialogVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form,
      "label-width": "125px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*名称"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "必填项"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "封面"
    }
  }, [_c('el-row', {
    staticClass: "row-bg",
    attrs: {
      "type": "flex"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Upload', {
    attrs: {
      "action": "/aries-api/resource/upload",
      "accept": "image/jpeg, image/gif, image/png",
      "before-upload": _vm.onBeforeUpload,
      "on-success": _vm.onSuccessUpload,
      "data": _vm.uploadData,
      "show-upload-list": false
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-upload",
      "circle": "",
      "size": "mini"
    }
  })], 1)], 1), _vm._v(" "), (_vm.form.imgUrl != '') ? _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.form.imgUrl,
      "width": "80px",
      "height": "80px"
    }
  })]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingBtn
    },
    on: {
      "click": _vm.confirmAddCp
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3422076f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/book/components/CPList.vue
// module id = 674
// module chunks = 1